import { render, staticRenderFns } from "./BidHistoryByLot.vue?vue&type=template&id=6a87c7a9"
import script from "./BidHistoryByLot.vue?vue&type=script&lang=js"
export * from "./BidHistoryByLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports